import { Facet } from '@ms/items-view/lib/private/models/Facet';
import { ShowInFiltersPaneStatus } from '@ms/odsp-datasources/lib/dataSources/item/spListItemProcessor/SPListItemEnums';

/** ShowInFiltersPane status, it can be Auto, Pinned or Removed */
export const showInFiltersPaneStatusFacet: Facet<ShowInFiltersPaneStatus> = new Facet('showInFiltersPaneStatus');

/**
 * Available choices array for field value.
 * For example LaunchBehavior field will contails choices array: ['In page navigation', 'Dialog', 'New tab']
 */
export const choicesFacet: Facet<string[]> = new Facet('choices');

/**
 * Whether the column is special url field in Link list
 */
export const isLinksListUrlFieldFacet: Facet<boolean> = new Facet('isLinksListUrlField');
